// Deal from /search/deals response, not deals how we store them in redux

export let DealGroupingChangeEvent;
(function (DealGroupingChangeEvent) {
  DealGroupingChangeEvent["ADVANCE"] = "ADVANCE";
  DealGroupingChangeEvent["REGRESS"] = "REGRESS";
  DealGroupingChangeEvent["NEW"] = "NEW";
  DealGroupingChangeEvent["UNCHANGED"] = "UNCHANGED";
  DealGroupingChangeEvent["MISSING"] = "MISSING";
  DealGroupingChangeEvent["REMOVED"] = "REMOVED";
})(DealGroupingChangeEvent || (DealGroupingChangeEvent = {}));
export let CloseDateProgress;
(function (CloseDateProgress) {
  CloseDateProgress["PUSH"] = "PUSH";
  CloseDateProgress["PULL"] = "PULL";
  CloseDateProgress["NEW"] = "NEW";
  CloseDateProgress["UNCHANGED"] = "UNCHANGED";
  CloseDateProgress["MISSING"] = "MISSING";
  CloseDateProgress["REMOVED"] = "REMOVED";
})(CloseDateProgress || (CloseDateProgress = {}));
export let AmountChangeEvent;
(function (AmountChangeEvent) {
  AmountChangeEvent["INCREASE"] = "INCREASE";
  AmountChangeEvent["DECREASE"] = "DECREASE";
  AmountChangeEvent["NEW"] = "NEW";
  AmountChangeEvent["UNCHANGED"] = "UNCHANGED";
  AmountChangeEvent["MISSING"] = "MISSING";
  AmountChangeEvent["REMOVED"] = "REMOVED";
})(AmountChangeEvent || (AmountChangeEvent = {})); // CrmObject from /search/deals response, type used for Deal audit history
// and DealSplit's crm object property